import {
  InteractionRequiredAuthError,
  PublicClientApplication,
  type AccountInfo,
} from "@azure/msal-browser";
export type MaybeAccount = AccountInfo | null;
const apiScopes = ["api://eadb4f43-df38-440b-8d27-0f8451689490/myapi"];
const config = {
  auth: {
    clientId: "eadb4f43-df38-440b-8d27-0f8451689490",
    redirectUri: window.location.origin + "/sign-in",
    postLogoutRedirectUri: "/logout",
  },
};
export const msal = new PublicClientApplication(config);

class Auth {
  initialized: boolean = false;
  private msalInitialized: boolean = false;
  account: MaybeAccount = null;
  isAuthenticated: boolean = false;

  async login(): Promise<void> {
    if (!this.msalInitialized) {
      await msal.initialize();
      this.msalInitialized = true;
    }
    await msal.loginRedirect({
      scopes: apiScopes,
    });
  }
  async initialize(): Promise<MaybeAccount> {
    try {
      // initialize msal if not already done
      if (!this.msalInitialized) {
        await msal.initialize();
        this.msalInitialized = true;
      }

      // start msal
      await msal.handleRedirectPromise();

      // grab and set account if in session
      const accounts = msal.getAllAccounts();
      if (accounts?.length) {
        this.setAccount(accounts[0]);
        await this.getAccessToken();
      }

      this.initialized = true;

      // return any active account
      return msal.getActiveAccount();
    } catch (ex) {
      console.error(ex);
      window.location.href = "/sign-in-failed";
    }
  }

  setAccount(account: MaybeAccount): void {
    msal.setActiveAccount(account);
    this.account = account;
    this.isAuthenticated = true;
  }

  async getAccessToken(): Promise<string> {
    const account = this.account ?? msal.getActiveAccount();
    if (!account) {
      throw new Error("Cannot acquire an access token without an active account");
    }

    try {
      const apiTokenResponse = await msal.acquireTokenSilent({
        account,
        scopes: apiScopes,
      });

      return apiTokenResponse.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await msal.acquireTokenRedirect({
          account,
          scopes: apiScopes,
        });
      }

      throw error;
    }
  }
}
const auth = new Auth();

export default auth;
